import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "cookie_choice_v1";

const CookieBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        let saved;
        try {
            saved = localStorage.getItem(KEY);
        } catch (e) {
            saved = "skip";
        }
        if (!saved) setVisible(true);
    }, []);

    const close = (choice) => {
        try {
            localStorage.setItem(KEY, choice);
        } catch (e) {
            /* ignore */
        }
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie" id="cookie">
            <div className="cookie__in">
                <p>
                    Сайт использует cookie и обрабатывает данные о посещении, чтобы работать
                    корректно и улучшать сервис. Продолжая пользоваться сайтом, вы соглашаетесь
                    с <Link to="/privacy">Политикой обработки персональных данных</Link>.
                </p>
                <div className="cookie__btns">
                    <button type="button" className="btn btn--sm" onClick={() => close("all")}>
                        Принять
                    </button>
                    <button type="button" className="linkbtn" onClick={() => close("necessary")}>
                        Только необходимые
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieBanner;
